import type { MovementInfo, MovementType } from '@az3fr/core';
import { createID } from '@az3fr/core';
import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';

// Factory Function
function createNewUserMovement(args: {
	name: string;
	description?: string;
	type?: MovementType;
}): MovementInfo {
	const { name, description, type } = args;
	const now = new Date().toISOString();
	return {
		id: createID('movement'),
		name,
		description: description ?? null,
		type: type ?? null,
		system: false, // must be false
		// @todo: it's hardcoded for now, we should change it when we have proper auth
		userId: '00000000-0000-0000-0000-000000000000',
		updatedAt: now,
		canonicalName: null,
	};
}

const movementAdapter = createEntityAdapter<MovementInfo>();
const movementSlice = createSlice({
	name: 'entities/movement',
	initialState: movementAdapter.getInitialState(),
	reducers: {
		addedOne: movementAdapter.addOne,
		addedMany: movementAdapter.addMany,

		updatedOne: movementAdapter.updateOne,
		updatedMany: movementAdapter.updateMany,

		removedOne: movementAdapter.removeOne,
		removedMany: movementAdapter.removeMany,
	},
});
type MovementSliceState = ReturnType<typeof movementAdapter.getInitialState>;

const movementSliceActions = { ...movementSlice.actions };
const movementSliceReducer = movementSlice.reducer;

export { createNewUserMovement, movementSliceActions, movementSliceReducer, movementAdapter };
export type { MovementSliceState };
